import { DialogComponent } from './dialog.js';
import { CartAddEvent } from './events.js';

class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();

    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    document.addEventListener('cart:add', this.#handleCartAdd);

    document.addEventListener('cart:updated', this.#handleCartUpdate);
    document.addEventListener('cart:update', this.#handleCartUpdate);
    document.addEventListener('cart:clear', this.#handleCartUpdate);
    document.addEventListener('cart:content:refreshed', this.#handleCartContentRefreshed);

    this.addEventListener('dialog:close', this.#handleDialogClose);

    const trigger = this.querySelector(
      '[data-testid="cart-drawer-trigger"], #cart-drawer-trigger-btn'
    );

    if (trigger) {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    }

    this.#setupCloseButtons();
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    document.removeEventListener('cart:add', this.#handleCartAdd);

    document.removeEventListener('cart:updated', this.#handleCartUpdate);
    document.removeEventListener('cart:update', this.#handleCartUpdate);
    document.removeEventListener('cart:clear', this.#handleCartUpdate);
    document.removeEventListener('cart:content:refreshed', this.#handleCartContentRefreshed);

    this.removeEventListener('dialog:close', this.#handleDialogClose);

    if (this._setupCloseButtonsTimeout) clearTimeout(this._setupCloseButtonsTimeout);
    if (this._observerTimeout) clearTimeout(this._observerTimeout);

    if (this._closeButtonObserver) {
      this._closeButtonObserver.disconnect();
      this._closeButtonObserver = null;
    }
  }

  updatedCallback() {
    super.updatedCallback();
    this.#setupCloseButtons();
  }

  #setupCloseButtons = () => {
    if (this._setupCloseButtonsTimeout) {
      clearTimeout(this._setupCloseButtonsTimeout);
    }

    this._setupCloseButtonsTimeout = setTimeout(() => {
      this._setupCloseButtonsTimeout = null;
      this.#doSetupCloseButtons();
    }, 50);
  };

  #doSetupCloseButtons = () => {
    let closeButtons = [];

    if (this.refs?.closeButton) {
      closeButtons = Array.isArray(this.refs.closeButton)
        ? this.refs.closeButton
        : [this.refs.closeButton];
    }

    if (!closeButtons.length) {
      closeButtons = Array.from(
        this.querySelectorAll('.cart-drawer__close-button, [ref="closeButton"]')
      );
    }

    closeButtons.forEach((button) => {
      if (!button || !(button instanceof HTMLElement)) return;

      if (button._closeHandler) {
        button.removeEventListener('click', button._closeHandler, true);
      }

      const handler = (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        this.close();
      };

      button._closeHandler = handler;
      button.addEventListener('click', handler, true);
    });

    const dialog = this.refs?.dialog || this.querySelector('dialog');

    if (dialog && !this._closeButtonObserver) {
      this._closeButtonObserver = new MutationObserver(() => {
        if (this._observerTimeout) clearTimeout(this._observerTimeout);

        this._observerTimeout = setTimeout(() => {
          this._observerTimeout = null;
          this.#doSetupCloseButtons();
        }, 100);
      });

      this._closeButtonObserver.observe(dialog, {
        childList: true,
        subtree: true,
      });
    }
  };

  #handleCartContentRefreshed = () => {
    this.#setupCloseButtons();
  };

  #handleDialogClose = () => {
    if (!this._isCartUpdateClosing) {
      this._userClosedTime = Date.now();
    }

    this._isCartUpdateClosing = false;
  };

  #toggleEmptyState(isEmpty) {
    const dialog = this.refs?.dialog || this.querySelector('dialog');

    const emptyState = this.querySelector(
      '.cart-drawer__empty-state, .cart-drawer__content--empty'
    );

    const emptyHeader = this.querySelector('.cart-drawer__header--empty');

    const cartContent = this.querySelector(
      '.cart-drawer__content:not(.cart-drawer__content--empty)'
    );

    const cartItemsList = this.querySelector('.cart-items__list');
    const cartItemsWrapper = this.querySelector('.cart-items');

    if (isEmpty) {
      emptyState?.removeAttribute('hidden');
      emptyHeader?.removeAttribute('hidden');

      if (emptyState) {
        emptyState.style.display = '';
        emptyState.style.visibility = '';
      }

      if (emptyHeader) {
        emptyHeader.style.display = '';
        emptyHeader.style.visibility = '';
      }

      if (cartContent) {
        cartContent.style.display = 'none';
        cartContent.style.visibility = 'hidden';
      }

      if (cartItemsList) cartItemsList.style.display = 'none';
      if (cartItemsWrapper) cartItemsWrapper.style.display = 'none';

      dialog?.classList.add('cart-drawer--empty');
    } else {
      if (emptyState) {
        emptyState.style.display = 'none';
        emptyState.style.visibility = 'hidden';
      }

      if (emptyHeader) {
        emptyHeader.style.display = 'none';
        emptyHeader.style.visibility = 'hidden';
      }

      if (cartContent) {
        cartContent.style.display = '';
        cartContent.style.visibility = '';
        cartContent.removeAttribute('hidden');
      }

      if (cartItemsList) {
        cartItemsList.style.display = '';
        cartItemsList.removeAttribute('hidden');
      }

      if (cartItemsWrapper) {
        cartItemsWrapper.style.display = '';
        cartItemsWrapper.removeAttribute('hidden');
      }

      dialog?.classList.remove('cart-drawer--empty');
    }
  }

  #getCartItemsComponent() {
    return (
      this.querySelector('cart-items-component') ||
      document.querySelector('cart-items-component')
    );
  }

  #refreshCartDrawer = async () => {
    console.log("refreshCartDrawer...............")
    console.log('refreshCartDrawer start', Date.now());
    try {
      const cart = await fetch('/cart.js', {
        cache: 'no-store',
      }).then((res) => res.json());

      const cartItems = this.#getCartItemsComponent();
      const sectionId = cartItems?.sectionId || cartItems?.dataset?.sectionId;

      if (cartItems && sectionId) {
        await this.#fetchAndMorphCartContent(cartItems, sectionId);
      }

      this.#toggleEmptyState(cart.item_count === 0);

      this.#updateCartTotals();

      document.dispatchEvent(
        new CustomEvent('cart:content:refreshed', {
          bubbles: true,
          detail: { cart },
        })
      );

      return cart;
    } catch (error) {
      console.warn('Cart drawer refresh failed:', error);
      return null;
    }
  };

  #updateCartTotals = () => {
    console.log(".....................updateCartTotals...............................wwwwwwwwwwwww")
    $.ajax({
      url: window.location.href,
      type: 'GET',

      success: function (response) {
        const $response = $(response); 

        // const newCount = $response.find('#cart-drawer-heading').text();
        // $('#cart-drawer-heading').text(newCount);

        const newTotal = $response.find('[data-cart-subtotal]').text();
        $('[data-cart-subtotal]').text(newTotal);

        const newTotalAttr = $response
          .find('.cart__total-value')
          .attr('cart-total-pice');

        $('.cart__total-value').attr('cart-total-pice', newTotalAttr);

        const newTotalValue = $response.find('.cart__total-value').attr('value');

        $('.cart__total-value').attr('value', newTotalValue);

        if ($('#use-credits-toggle').is(':checked')) {

          // let totalPrice = 0;

          // document
          //   .querySelectorAll(
          //     '.cart-item-card.credit-price-enabled[data-new-release="true"]'
          //   )
          //   .forEach(function (item) {
          //     const priceEl = item.querySelector('.regular__price');
          //     if (!priceEl) return;

          //     const rawPrice = priceEl.getAttribute('item-price') || '0';
          //     const itemPrice = parseFloat(rawPrice.replace(/,/g, '')) || 0;

          //     totalPrice += itemPrice;
          //   });

                let totalPrice = 0;

                const totalCredits = Number(getCreditDeduction() || 0);

                console.log("totalCredits................333333333333333",totalCredits)

                let remainingCredits = totalCredits;
                const items = document
                  .querySelectorAll(
                    '.cart-item-card.credit-price-enabled[data-new-release="true"]'
                  )

                items.forEach(function (item) {

                  const priceEl = item.querySelector('.regular__price');
                  if (!priceEl) return;

                  const rawPrice = priceEl.getAttribute('item-price') || '0';

                  // full line price
                  const linePrice = parseFloat(rawPrice.replace(/,/g, '')) || 0;

                  const qty = Number(item.getAttribute('total-qty') || 1);

                  // per qty price
                  const unitPrice = linePrice / qty;

                  // kitni qty free hogi
                  const discountedQty = Math.min(qty, remainingCredits);

                  // sirf discount amount calculate
                  totalPrice += discountedQty * unitPrice;

                  remainingCredits -= discountedQty;

                });


          const totalCart =
            parseFloat((newTotalAttr || '0').replace(/,/g, '')) || 0;

          $('.credit_discount_apply .credit_discount span').html(
            totalPrice.toLocaleString('en-IN', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })
          );

          $('.credit_discount_apply .total_credit_amount span').html(
            (totalCart - totalPrice).toLocaleString('en-IN', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })
          );

          // const usedCredit = $('.cart-item-card.credit-price-enabled[data-new-release="true"]').length;

          let UsedCredit = 0;

          $('.cart-item-card.credit-price-enabled[data-new-release="true"]').each(function () {
            const qty = Number($(this).attr('total-qty') || 1);
            UsedCredit += qty;
          });

          // actual usable credits
          UsedCredit = Math.min(UsedCredit, totalCredits);

          console.log("update UsedCredit ................",UsedCredit)
          
          $('.cart__credits-usage-label span').text(UsedCredit);


          const creditsEl = document.getElementById('credits-deduction');

          if (creditsEl) {
            creditsEl.innerHTML = `${remainingCredits} <strong>credits remaining</strong>`;
          }

        }
      },

      error: function (xhr, status, error) {
        console.log(error);
      },
    });
  };

  #handleCartUpdate = async (event) => {
    console.log('Cart Update Triggered');

    const recentlyClosed =
      this._userClosedTime && Date.now() - this._userClosedTime < 1000;

    const cart = await this.#refreshCartDrawer();

    if (cart) {
      this.#toggleEmptyState(cart.item_count === 0);
    }

    if (this.refs?.dialog?.open && !recentlyClosed) {
      requestAnimationFrame(() => {
        if (!this.refs?.dialog?.open && !recentlyClosed) {
          this._isCartUpdateClosing = true;
          this.showDialog();
        }
      });
    }
  };

  #handleCartAdd = async (event) => {
    if (!this.hasAttribute('auto-open')) return;

    this._openingFromCartAdd = true;
    this.showDialog();

    const dialog = this.refs?.dialog || this.querySelector('dialog');

    const emptyState = this.querySelector(
      '.cart-drawer__empty-state, .cart-drawer__content--empty'
    );

    const emptyHeader = this.querySelector('.cart-drawer__header--empty');

    if (emptyState) {
      emptyState.style.display = 'none';
      emptyState.style.visibility = 'hidden';
    }

    if (emptyHeader) {
      emptyHeader.style.display = 'none';
      emptyHeader.style.visibility = 'hidden';
    }

    dialog?.classList.remove('cart-drawer--empty');

    document.dispatchEvent(
      new CustomEvent('cart:drawer:open', {
        bubbles: true,
        detail: { drawer: this },
      })
    );

    await this.#refreshCartDrawer();

    this._openingFromCartAdd = false;

    requestAnimationFrame(() => {
      this.#setupCloseButtons();
    });
  };

  #morphCartContent = async (cartItems, sectionId, sectionHTML) => {
    try {
      const sectionRendererUrl =
        window.SHOPIFY_SECTION_RENDERER_URL ||
        new URL('./section-renderer.js', import.meta.url).href;

      const { morphSection, sectionRenderer } = await import(sectionRendererUrl);

      sectionRenderer.clearCache(sectionId);

      await morphSection(sectionId, sectionHTML);

      if (typeof cartItems.updatedCallback === 'function') {
        cartItems.updatedCallback();
      }

      requestAnimationFrame(() => {
        if (typeof this.updatedCallback === 'function') {
          this.updatedCallback();
        }

        document.dispatchEvent(
          new CustomEvent('cart:content:refreshed', {
            bubbles: true,
          })
        );
      });
    } catch (error) {
      await this.#fetchAndMorphCartContent(cartItems, sectionId);
    }
  };

  #fetchAndMorphCartContent = async (cartItems, sectionId) => {
    try {
      const sectionRendererUrl =
        window.SHOPIFY_SECTION_RENDERER_URL ||
        new URL('./section-renderer.js', import.meta.url).href;

      const { sectionRenderer } = await import(sectionRendererUrl);

      sectionRenderer.clearCache(sectionId);

      await sectionRenderer.renderSection(sectionId, {
        cache: false,
      });

      if (typeof cartItems.updatedCallback === 'function') {
        cartItems.updatedCallback();
      }

      requestAnimationFrame(() => {
        if (typeof this.updatedCallback === 'function') {
          this.updatedCallback();
        }

        document.dispatchEvent(
          new CustomEvent('cart:content:refreshed', {
            bubbles: true,
          })
        );
      });
    } catch (error) {
      console.warn('Fetch and morph cart content failed:', error);
    }
  };

  open() {
    this._userClosedTime = null;
    this.showDialog();

    requestAnimationFrame(() => {
      document.dispatchEvent(
        new CustomEvent('cart:drawer:open', {
          bubbles: true,
          detail: { drawer: this },
        })
      );

      setTimeout(() => {
        if (typeof window.refreshCartItemsAudio === 'function') {
          window.refreshCartItemsAudio();
        }
      }, 600);
    });

    if (!this._openingFromCartAdd) {
      this.#refreshCartDrawer();
    }

    requestAnimationFrame(() => {
      this.#setupCloseButtons();
    });

    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent =
        document.querySelector('shopify-payment-terms')?.shadowRoot;

      const cta = installmentsContent?.querySelector('#shopify-installments-cta');

      cta?.addEventListener('click', this.closeDialog, {
        once: true,
      });
    });
  }

  close() {
    this._userClosedTime = Date.now();
    this._isCartUpdateClosing = false;
    this.closeDialog();
  }
}

// if (!customElements.get('cart-drawer-component')) {
//   customElements.define('cart-drawer-component', CartDrawerComponent);
// }

// $(document).on('click', '.cart-item-card__remove', function () {
//   const $cartInner = $('.cart-drawer__inner');

//   $cartInner.css({
//     opacity: '0.5',
//     transition: '0.2s ease',
//   });

//   $('cart-items-component .cart__total-container').addClass('active');

//   // trigger cart update
//   document.dispatchEvent(
//     new CustomEvent('cart:update', {
//       bubbles: true,
//     })
//   );

//   setTimeout(() => {
//     $cartInner.css({
//       opacity: '1',
//     });

//     $('cart-items-component .cart__total-container').removeClass('active');
//   }, 1200);
// });








// import { DialogComponent } from './dialog.js';
// import { CartAddEvent } from './events.js';

// class CartDrawerComponent extends DialogComponent {
//   connectedCallback() {
//     super.connectedCallback();

//     document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
//     document.addEventListener('cart:add', this.#handleCartAdd);

//     document.addEventListener('cart:updated', this.#handleCartUpdate);
//     document.addEventListener('cart:update', this.#handleCartUpdate);
//     document.addEventListener('cart:clear', this.#handleCartUpdate);
//     document.addEventListener(
//       'cart:content:refreshed',
//       this.#handleCartContentRefreshed
//     );

//     this.addEventListener('dialog:close', this.#handleDialogClose);

//     const trigger = this.querySelector(
//       '[data-testid="cart-drawer-trigger"], #cart-drawer-trigger-btn'
//     );

//     if (trigger) {
//       trigger.addEventListener('click', (e) => {
//         e.preventDefault();
//         this.open();
//       });
//     }

//     this.#setupCloseButtons();
//   }

//   disconnectedCallback() {
//     super.disconnectedCallback();

//     document.removeEventListener(
//       CartAddEvent.eventName,
//       this.#handleCartAdd
//     );
//     document.removeEventListener('cart:add', this.#handleCartAdd);

//     document.removeEventListener('cart:updated', this.#handleCartUpdate);
//     document.removeEventListener('cart:update', this.#handleCartUpdate);
//     document.removeEventListener('cart:clear', this.#handleCartUpdate);

//     document.removeEventListener(
//       'cart:content:refreshed',
//       this.#handleCartContentRefreshed
//     );

//     this.removeEventListener('dialog:close', this.#handleDialogClose);

//     if (this._setupCloseButtonsTimeout) {
//       clearTimeout(this._setupCloseButtonsTimeout);
//     }

//     if (this._observerTimeout) {
//       clearTimeout(this._observerTimeout);
//     }

//     if (this._closeButtonObserver) {
//       this._closeButtonObserver.disconnect();
//       this._closeButtonObserver = null;
//     }
//   }

//   updatedCallback() {
//     super.updatedCallback();
//     this.#setupCloseButtons();
//   }

//   #setupCloseButtons = () => {
//     if (this._setupCloseButtonsTimeout) {
//       clearTimeout(this._setupCloseButtonsTimeout);
//     }

//     this._setupCloseButtonsTimeout = setTimeout(() => {
//       this._setupCloseButtonsTimeout = null;
//       this.#doSetupCloseButtons();
//     }, 50);
//   };

//   #doSetupCloseButtons = () => {
//     let closeButtons = [];

//     if (this.refs?.closeButton) {
//       closeButtons = Array.isArray(this.refs.closeButton)
//         ? this.refs.closeButton
//         : [this.refs.closeButton];
//     }

//     if (!closeButtons.length) {
//       closeButtons = Array.from(
//         this.querySelectorAll(
//           '.cart-drawer__close-button, [ref="closeButton"]'
//         )
//       );
//     }

//     closeButtons.forEach((button) => {
//       if (!button || !(button instanceof HTMLElement)) return;

//       if (button._closeHandler) {
//         button.removeEventListener('click', button._closeHandler, true);
//       }

//       const handler = (e) => {
//         e.preventDefault();
//         e.stopPropagation();
//         e.stopImmediatePropagation();
//         this.close();
//       };

//       button._closeHandler = handler;

//       button.addEventListener('click', handler, true);
//     });

//     const dialog = this.refs?.dialog || this.querySelector('dialog');

//     if (dialog && !this._closeButtonObserver) {
//       this._closeButtonObserver = new MutationObserver(() => {
//         if (this._observerTimeout) {
//           clearTimeout(this._observerTimeout);
//         }

//         this._observerTimeout = setTimeout(() => {
//           this._observerTimeout = null;
//           this.#doSetupCloseButtons();
//         }, 100);
//       });

//       this._closeButtonObserver.observe(dialog, {
//         childList: true,
//         subtree: true,
//       });
//     }
//   };

//   #handleCartContentRefreshed = () => {
//     const $cartInner = $('.cart-drawer__inner');

//     $cartInner.css({
//       opacity: '1',
//       pointerEvents: '',
//       transition: '0.2s ease',
//     });

//     $('cart-items-component .cart__total-container').removeClass('active');

//     this.#setupCloseButtons();
//   };

//   #handleDialogClose = () => {
//     if (!this._isCartUpdateClosing) {
//       this._userClosedTime = Date.now();
//     }

//     this._isCartUpdateClosing = false;
//   };

//   #toggleEmptyState(isEmpty) {
//     const dialog = this.refs?.dialog || this.querySelector('dialog');

//     const emptyState = this.querySelector(
//       '.cart-drawer__empty-state, .cart-drawer__content--empty'
//     );

//     const emptyHeader = this.querySelector('.cart-drawer__header--empty');

//     const cartContent = this.querySelector(
//       '.cart-drawer__content:not(.cart-drawer__content--empty)'
//     );

//     const cartItemsList = this.querySelector('.cart-items__list');

//     const cartItemsWrapper = this.querySelector('.cart-items');

//     if (isEmpty) {
//       emptyState?.removeAttribute('hidden');
//       emptyHeader?.removeAttribute('hidden');

//       if (emptyState) {
//         emptyState.style.display = '';
//         emptyState.style.visibility = '';
//       }

//       if (emptyHeader) {
//         emptyHeader.style.display = '';
//         emptyHeader.style.visibility = '';
//       }

//       if (cartContent) {
//         cartContent.style.display = 'none';
//         cartContent.style.visibility = 'hidden';
//       }

//       if (cartItemsList) {
//         cartItemsList.style.display = 'none';
//       }

//       if (cartItemsWrapper) {
//         cartItemsWrapper.style.display = 'none';
//       }

//       dialog?.classList.add('cart-drawer--empty');
//     } else {
//       if (emptyState) {
//         emptyState.style.display = 'none';
//         emptyState.style.visibility = 'hidden';
//       }

//       if (emptyHeader) {
//         emptyHeader.style.display = 'none';
//         emptyHeader.style.visibility = 'hidden';
//       }

//       if (cartContent) {
//         cartContent.style.display = '';
//         cartContent.style.visibility = '';
//         cartContent.removeAttribute('hidden');
//       }

//       if (cartItemsList) {
//         cartItemsList.style.display = '';
//         cartItemsList.removeAttribute('hidden');
//       }

//       if (cartItemsWrapper) {
//         cartItemsWrapper.style.display = '';
//         cartItemsWrapper.removeAttribute('hidden');
//       }

//       dialog?.classList.remove('cart-drawer--empty');
//     }
//   }

//   #getCartItemsComponent() {
//     return (
//       this.querySelector('cart-items-component') ||
//       document.querySelector('cart-items-component')
//     );
//   }

//   #refreshCartDrawer = async () => {
//     try {
//       const cart = await fetch('/cart.js', {
//         cache: 'no-store',
//       }).then((res) => res.json());

//       const cartItems = this.#getCartItemsComponent();

//       const sectionId =
//         cartItems?.sectionId || cartItems?.dataset?.sectionId;

//       if (cartItems && sectionId) {
//         await this.#fetchAndMorphCartContent(cartItems, sectionId);
//       }

//       this.#toggleEmptyState(cart.item_count === 0);

//       this.#updateCartTotals();

//       document.dispatchEvent(
//         new CustomEvent('cart:content:refreshed', {
//           bubbles: true,
//           detail: { cart },
//         })
//       );

//       return cart;
//     } catch (error) {
//       console.warn('Cart drawer refresh failed:', error);
//       return null;
//     }
//   };

//   #updateCartTotals = () => {
//     $.ajax({
//       url: '/cart',

//       type: 'GET',

//       success: function (response) {
//         const $response = $(response);

//         const newCount = $response.find('#cart-drawer-heading').text();

//         $('#cart-drawer-heading').text(newCount);

//         const newTotal = $response.find('[data-cart-subtotal]').text();

//         $('[data-cart-subtotal]').text(newTotal);

//         const newTotalAttr = $response
//           .find('.cart__total-value')
//           .attr('cart-total-pice');

//         $('.cart__total-value').attr(
//           'cart-total-pice',
//           newTotalAttr
//         );

//         const newTotalValue = $response
//           .find('.cart__total-value')
//           .attr('value');

//         $('.cart__total-value').attr('value', newTotalValue);

//         if ($('#use-credits-toggle').is(':checked')) {
//           let totalPrice = 0;

//           document
//             .querySelectorAll(
//               '.cart-item-card.credit-price-enabled[data-new-release="true"]'
//             )
//             .forEach(function (item) {
//               const priceEl = item.querySelector('.regular__price');

//               if (!priceEl) return;

//               const rawPrice =
//                 priceEl.getAttribute('item-price') || '0';

//               const itemPrice =
//                 parseFloat(rawPrice.replace(/,/g, '')) || 0;

//               totalPrice += itemPrice;
//             });

//           const totalCart =
//             parseFloat((newTotalAttr || '0').replace(/,/g, '')) || 0;

//           $('.credit_discount_apply .credit_discount span').html(
//             totalPrice.toLocaleString('en-IN', {
//               minimumFractionDigits: 2,
//               maximumFractionDigits: 2,
//             })
//           );

//           $('.credit_discount_apply .total_credit_amount span').html(
//             (totalCart - totalPrice).toLocaleString('en-IN', {
//               minimumFractionDigits: 2,
//               maximumFractionDigits: 2,
//             })
//           );

//           const usedCredit = $(
//             '.cart-item-card.credit-price-enabled[data-new-release="true"]'
//           ).length;

//           $('.cart__credits-usage-label span').text(usedCredit);
//         }
//       },

//       error: function (xhr, status, error) {
//         console.log(error);
//       },
//     });
//   };

//   #handleCartUpdate = async () => {
//     console.log('Cart Update Triggered');

//     const recentlyClosed =
//       this._userClosedTime &&
//       Date.now() - this._userClosedTime < 1000;

//     const cart = await this.#refreshCartDrawer();

//     if (cart) {
//       this.#toggleEmptyState(cart.item_count === 0);
//     }

//     if (this.refs?.dialog?.open && !recentlyClosed) {
//       requestAnimationFrame(() => {
//         if (!this.refs?.dialog?.open && !recentlyClosed) {
//           this._isCartUpdateClosing = true;
//           this.showDialog();
//         }
//       });
//     }
//   };

//   #handleCartAdd = async () => {
//     if (!this.hasAttribute('auto-open')) return;

//     this._openingFromCartAdd = true;

//     this.showDialog();

//     const dialog = this.refs?.dialog || this.querySelector('dialog');

//     const emptyState = this.querySelector(
//       '.cart-drawer__empty-state, .cart-drawer__content--empty'
//     );

//     const emptyHeader = this.querySelector(
//       '.cart-drawer__header--empty'
//     );

//     if (emptyState) {
//       emptyState.style.display = 'none';
//       emptyState.style.visibility = 'hidden';
//     }

//     if (emptyHeader) {
//       emptyHeader.style.display = 'none';
//       emptyHeader.style.visibility = 'hidden';
//     }

//     dialog?.classList.remove('cart-drawer--empty');

//     document.dispatchEvent(
//       new CustomEvent('cart:drawer:open', {
//         bubbles: true,
//         detail: { drawer: this },
//       })
//     );

//     await this.#refreshCartDrawer();

//     this._openingFromCartAdd = false;

//     requestAnimationFrame(() => {
//       this.#setupCloseButtons();
//     });
//   };

//   #morphCartContent = async (
//     cartItems,
//     sectionId,
//     sectionHTML
//   ) => {
//     try {
//       const sectionRendererUrl =
//         window.SHOPIFY_SECTION_RENDERER_URL ||
//         new URL('./section-renderer.js', import.meta.url).href;

//       const { morphSection, sectionRenderer } = await import(
//         sectionRendererUrl
//       );

//       sectionRenderer.clearCache(sectionId);

//       await morphSection(sectionId, sectionHTML);

//       if (typeof cartItems.updatedCallback === 'function') {
//         cartItems.updatedCallback();
//       }

//       requestAnimationFrame(() => {
//         if (typeof this.updatedCallback === 'function') {
//           this.updatedCallback();
//         }

//         document.dispatchEvent(
//           new CustomEvent('cart:content:refreshed', {
//             bubbles: true,
//           })
//         );
//       });
//     } catch (error) {
//       await this.#fetchAndMorphCartContent(cartItems, sectionId);
//     }
//   };

//   #fetchAndMorphCartContent = async (
//     cartItems,
//     sectionId
//   ) => {
//     try {
//       const sectionRendererUrl =
//         window.SHOPIFY_SECTION_RENDERER_URL ||
//         new URL('./section-renderer.js', import.meta.url).href;

//       const { sectionRenderer } = await import(
//         sectionRendererUrl
//       );

//       sectionRenderer.clearCache(sectionId);

//       await sectionRenderer.renderSection(sectionId, {
//         cache: false,
//       });

//       if (typeof cartItems.updatedCallback === 'function') {
//         cartItems.updatedCallback();
//       }

//       requestAnimationFrame(() => {
//         if (typeof this.updatedCallback === 'function') {
//           this.updatedCallback();
//         }

//         document.dispatchEvent(
//           new CustomEvent('cart:content:refreshed', {
//             bubbles: true,
//           })
//         );
//       });
//     } catch (error) {
//       console.warn(
//         'Fetch and morph cart content failed:',
//         error
//       );
//     }
//   };

//   open() {
//     this._userClosedTime = null;

//     this.showDialog();

//     requestAnimationFrame(() => {
//       document.dispatchEvent(
//         new CustomEvent('cart:drawer:open', {
//           bubbles: true,
//           detail: { drawer: this },
//         })
//       );

//       setTimeout(() => {
//         if (
//           typeof window.refreshCartItemsAudio === 'function'
//         ) {
//           window.refreshCartItemsAudio();
//         }
//       }, 600);
//     });

//     if (!this._openingFromCartAdd) {
//       this.#refreshCartDrawer();
//     }

//     requestAnimationFrame(() => {
//       this.#setupCloseButtons();
//     });

//     customElements
//       .whenDefined('shopify-payment-terms')
//       .then(() => {
//         const installmentsContent =
//           document.querySelector('shopify-payment-terms')
//             ?.shadowRoot;

//         const cta =
//           installmentsContent?.querySelector(
//             '#shopify-installments-cta'
//           );

//         cta?.addEventListener('click', this.closeDialog, {
//           once: true,
//         });
//       });
//   }

//   close() {
//     this._userClosedTime = Date.now();
//     this._isCartUpdateClosing = false;
//     this.closeDialog();
//   }
// }

if (!customElements.get('cart-drawer-component')) {
  customElements.define(
    'cart-drawer-component',
    CartDrawerComponent
  );
}

/*
|--------------------------------------------------------------------------
| REMOVE BUTTON LOADING ONLY
|--------------------------------------------------------------------------
| IMPORTANT:
| DO NOT dispatch cart:update manually here.
| Shopify/internal component already handles remove event.
|--------------------------------------------------------------------------
*/

// $(document).on('click', '.cart-item-card__remove', async function (e) {

//   e.preventDefault();
//   e.stopPropagation();

//   const line = $(this).data('line');

//   if (!line) {
//     console.log('Line item missing');
//     return;
//   }

//   const $cartInner = $('.cart-drawer__inner');

//   $cartInner.css({
//     opacity: '0.5',
//     pointerEvents: 'none',
//     transition: '0.2s ease'
//   });

//   $('cart-items-component .cart__total-container')
//     .addClass('active');

//   try {

//     await fetch('/cart/change.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify({
//         line: line,
//         quantity: 0
//       })
//     });

//     document.dispatchEvent(
//       new CustomEvent('cart:updated', {
//         bubbles: true
//       })
//     );

//   } catch (error) {

//     console.error('Remove failed:', error);

//   } finally {

//     setTimeout(() => {

//       $cartInner.css({
//         opacity: '1',
//         pointerEvents: ''
//       });

//       $('cart-items-component .cart__total-container')
//         .removeClass('active');

//     }, 4000);
//   }

// });

// function getCreditDeduction() {
//   const creditEl = document.getElementById('credits-deduction');
//   const value = creditEl?.textContent?.trim() || '0';
//   return parseInt(value, 10) || 0;
// }



// $(document).on('click', '.cart-item-card__remove', async function (e) {

//   e.preventDefault();
//   e.stopPropagation();

//   // const line = $(this).parents('article.cart-item-card').attr('data-key');
//   const line = $(this).closest('article.cart-item-card').attr('data-key');
//   console.log(line,'ldkk')

//   // if (!line) {
//   //   console.log('Line item missing');
//   //   return;
//   // }

//   const $cartInner = $('.cart-drawer__inner');

//   $cartInner.css({
//     opacity: '0.5',
//     pointerEvents: 'none',
//     transition: '0.2s ease'
//   });

//   $('cart-items-component .cart__total-container')
//     .addClass('active');

//   try {

//     // remove item
//     await fetch('/cart/change.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify({
//         line: line,
//         quantity: 0
//       })
//     });

//     // get updated cart
//     const cartResponse = await fetch('/cart.js', {
//       cache: 'no-store'
//     });

//     const cartData = await cartResponse.json();

//     // update cart heading count
//     const cartHeading = document.querySelector('#cart-drawer-heading');

//     if (cartHeading) {
//       cartHeading.textContent = `Cart (${cartData.item_count})`;
//     }

//     // update header/cart bubble counts
//     document.querySelectorAll(
//       '[data-cart-count], .cart-count-bubble span, .header__cart-count, .cart-count'
//     ).forEach((el) => {
//       el.textContent = cartData.item_count;
//     });

//     // cart updated event
//     document.dispatchEvent(
//       new CustomEvent('cart:updated', {
//         bubbles: true,
//         detail: {
//           cart: cartData
//         }
//       })
//     );

//     $.ajax({
//       url: window.location.href,
//       type: 'GET',

//       success: function (response) {
//         const $response = $(response); 

//         const newCount = $response.find('#cart-drawer-heading').text();
//         // $('#cart-drawer-heading').text(newCount);

//         const newTotal = $response.find('[data-cart-subtotal]').text();
//         $('[data-cart-subtotal]').text(newTotal);

//         const newTotalAttr = $response
//           .find('.cart__total-value')
//           .attr('cart-total-pice');

//         $('.cart__total-value').attr('cart-total-pice', newTotalAttr);

//         const newTotalValue = $response.find('.cart__total-value').attr('value');

//         $('.cart__total-value').attr('value', newTotalValue);

//         if ($('#use-credits-toggle').is(':checked')) {
        

//                 let totalPrice = 0;

//                 const totalCredits = Number(getCreditDeduction() || 0);

//                 let remainingCredits = totalCredits;
//                 const items = document
//                   .querySelectorAll(
//                     '.cart-item-card.credit-price-enabled[data-new-release="true"]'
//                   )

//                 items.forEach(function (item) {

//                   const priceEl = item.querySelector('.regular__price');
//                   if (!priceEl) return;

//                   const rawPrice = priceEl.getAttribute('item-price') || '0';

//                   // full line price
//                   const linePrice = parseFloat(rawPrice.replace(/,/g, '')) || 0;

//                   const qty = Number(item.getAttribute('total-qty') || 1);

//                   // per qty price
//                   const unitPrice = linePrice / qty;

//                   // kitni qty free hogi
//                   const discountedQty = Math.min(qty, remainingCredits);

//                   // sirf discount amount calculate
//                   totalPrice += discountedQty * unitPrice;

//                   remainingCredits -= discountedQty;

//                   console.log({
//                     qty,
//                     linePrice,
//                     unitPrice,
//                     discountedQty,
//                     totalPrice
//                   });

//                 });


//           const totalCart =
//             parseFloat((newTotalAttr || '0').replace(/,/g, '')) || 0;

//           $('.credit_discount_apply .credit_discount span').html(
//             totalPrice.toLocaleString('en-IN', {
//               minimumFractionDigits: 2,
//               maximumFractionDigits: 2,
//             })
//           );

//           $('.credit_discount_apply .total_credit_amount span').html(
//             (totalCart - totalPrice).toLocaleString('en-IN', {
//               minimumFractionDigits: 2,
//               maximumFractionDigits: 2,
//             })
//           );

//           const usedCredit = $(
//             '.cart-item-card.credit-price-enabled[data-new-release="true"]'
//           ).length;

//           $('.cart__credits-usage-label span').text(usedCredit);
//         }
//       },

//       error: function (xhr, status, error) {
//         console.log(error);
//       },
//     });
//   } catch (error) {

//     console.error('Remove failed:', error);

//   } finally {

//     setTimeout(() => {

//       $cartInner.css({
//         opacity: '1',
//         pointerEvents: ''
//       });

//       $('cart-items-component .cart__total-container')
//         .removeClass('active');

//     }, 400);

//   }

// });


// function getCreditDeduction() {
//   const creditEl = document.getElementById('credits-deduction');
//   const value = creditEl?.textContent?.trim() || '0';
//   return parseInt(value, 10) || 0;
// }

function getCreditDeduction() {
  return Number(window.customerCredits || 0);
}

function formatMoneyIN(amount) {
  return Number(amount || 0).toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

function recalculateCreditTotals(totalCart) {
  let discountAmount = 0;
  let usedCredits = 0;

  const totalCredits = Number(getCreditDeduction() || 0);
  console.log("totalCredits ...............4444444",totalCredits)
  let remainingCredits = totalCredits;

  const items = document.querySelectorAll(
    '.cart-item-card.credit-price-enabled[data-new-release="true"]'
  );

  items.forEach(function (item) {
    if (remainingCredits <= 0) return;

    const priceEl = item.querySelector('.regular__price');
    if (!priceEl) return;

    const rawPrice = priceEl.getAttribute('item-price') || '0';
    const linePrice = parseFloat(rawPrice.replace(/,/g, '')) || 0;

    const qty = Math.max(Number(item.getAttribute('total-qty') || 1), 1);
    const unitPrice = linePrice / qty;

    const discountedQty = Math.min(qty, remainingCredits);

    discountAmount += discountedQty * unitPrice;
    usedCredits += discountedQty;
    remainingCredits -= discountedQty;
  });

  const finalTotal = Math.max(totalCart - discountAmount, 0);

  $('.credit_discount_apply .credit_discount span').html(
    formatMoneyIN(discountAmount)
  );

  $('.credit_discount_apply .total_credit_amount span').html(
    formatMoneyIN(finalTotal)
  );
  console.log("recalculateCreditTotals usedCredits .....................",usedCredits)
  $('.cart__credits-usage-label span').text(usedCredits);

  const creditsEl = document.getElementById('credits-deduction');

  if (creditsEl) {
    creditsEl.innerHTML = `${remainingCredits} <strong>credits remaining</strong>`;
  }
}

// $(document)
//   .off('click.cartRemove', '.cart-item-card__remove')
//   .on('click.cartRemove', '.cart-item-card__remove', async function (e) {
//     e.preventDefault();
//     e.stopPropagation();

//   const itemKey = $(this).closest('article.cart-item-card').attr('data-key');

//   const $currentItem = $(this).closest('article.cart-item-card');

//   const isCustomVocalOrder =
//     $currentItem.text().includes('Custom Vocal Order');

//   const isRushCharge =
//     $currentItem.text().includes('Rush Charges');


//   let linkedItemKey = null;

//   if (isCustomVocalOrder || isRushCharge) {

//     const cartBeforeRemove = await fetch('/cart.js', {
//       cache: 'no-store'
//     }).then(r => r.json());

//     if (isCustomVocalOrder) {

//       const rushItem = cartBeforeRemove.items.find(item =>
//         item.product_title === 'Rush Charges' ||
//         item.title.includes('Rush Charges') ||
//         item.properties?._rush_charge === 'true'
//       );

//       linkedItemKey = rushItem?.key;

//     } else {

//       const customItem = cartBeforeRemove.items.find(item =>
//         item.product_title === 'Custom Vocal Order' &&
//         item.properties &&
//         Object.keys(item.properties).some(key =>
//           key.includes('Your Name')
//         )
//       );

//       linkedItemKey = customItem?.key;

//     }

//   }

//   if (linkedItemKey) {

//     await fetch('/cart/change.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         Accept: 'application/json',
//       },
//       body: JSON.stringify({
//         id: linkedItemKey,
//         quantity: 0,
//       }),
//     });

//   }

//   if (linkedItemKey) {
//     $(`article.cart-item-card[data-key="${linkedItemKey}"]`).remove();
//   }



//   if (!itemKey) {
//     console.log('Cart item key missing');
//     return;
//   }
//   console.log('Delete clicked');
//   console.log('Item key:', itemKey);
//   console.log('Time:', Date.now());

//   const $cartInner = $('.cart-drawer__inner');

//   $cartInner.css({
//     opacity: '0.5',
//     pointerEvents: 'none',
//     transition: '0.2s ease',
//   });

//   $('cart-items-component .cart__total-container').addClass('active');

//   try {
//     const changeResponse = await fetch('/cart/change.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         Accept: 'application/json',
//       },
//       body: JSON.stringify({
//         id: itemKey,
//         quantity: 0,
//       }),
//     });

//     const responseText = await changeResponse.text();

//     if (!changeResponse.ok) {
//       console.error('Cart change failed:', {
//         status: changeResponse.status,
//         response: responseText,
//         itemKey,
//       });
//       throw new Error('Cart item remove failed');
//     }

//     const cartData = JSON.parse(responseText);


//     let finalCartData = cartData;

//     if (rushItemKey) {
//       const rushRemoveResponse = await fetch('/cart/change.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           Accept: 'application/json',
//         },
//         body: JSON.stringify({
//           id: rushItemKey,
//           quantity: 0,
//         }),
//       });

//       if (rushRemoveResponse.ok) {
//         finalCartData = await rushRemoveResponse.json();
//       }
//     }


//     // const changeResponse = await fetch('/cart/change.js', {
//     //   method: 'POST',
//     //   headers: {
//     //     'Content-Type': 'application/json',
//     //     Accept: 'application/json',
//     //   },
//     //   body: JSON.stringify({
//     //     id: itemKey,
//     //     quantity: 0,
//     //   }),
//     // });

//     // if (!changeResponse.ok) {
//     //   throw new Error('Cart item remove failed');
//     // }

//     // const cartResponse = await fetch('/cart.js', {
//     //   cache: 'no-store',
//     // });

//     // const cartData = await cartResponse.json();


//     // Custom
//    let displayCount = 0;

//     finalCartData.items.forEach((item) => {

//       const hasCustomProperty =
//         item.properties &&
//         Object.keys(item.properties).some(
//           key => key.includes('Your Name')
//         );

//       if (hasCustomProperty) {

//         // Custom Vocal Order
//         displayCount += 1;

//       } else {

//         // Normal products
//         displayCount += item.quantity;

//       }

//     });

//     const cartHeading = document.querySelector('#cart-drawer-heading');

//     if (cartHeading) {
//       cartHeading.textContent = `Cart (${displayCount})`;
//     }

//     const bubble = document.querySelector(".cart-bubble__text-count");

//     if (bubble) {
//       bubble.textContent = displayCount;
//       bubble.setAttribute("data-unique-count", displayCount);
//     }

//     // const cartHeading = document.querySelector('#cart-drawer-heading');

//     // if (cartHeading) {
//     //   cartHeading.textContent = `Cart (${cartData.item_count})`;
//     // }

//     // // Bubble update
//     // const bubble = document.querySelector(".cart-bubble__text-count");

//     // if (bubble) {
//     //   // text update
//     //   bubble.textContent = cartData.item_count;

//     //   // attribute update
//     //   bubble.setAttribute("data-unique-count", cartData.item_count);

//     // }



//     document
//       .querySelectorAll(
//         '[data-cart-count], .cart-count-bubble span, .header__cart-count, .cart-count'
//       )
//       .forEach((el) => {
//         el.textContent = displayCount;
//       });

//     document.dispatchEvent(
//       new CustomEvent('cart:updated', {
//         bubbles: true,
//         detail: {
//           cart: finalCartData,
//         },
//       })
//     );

//     $.ajax({
//       url: window.location.href,
//       type: 'GET',
//       cache: false,

//       success: function (response) {
//         const $response = $(response);

//         const newTotal = $response.find('[data-cart-subtotal]').text();
//         $('[data-cart-subtotal]').text(newTotal);

//         const newTotalAttr = $response
//           .find('.cart__total-value')
//           .attr('cart-total-pice');

//         const newTotalValue = $response.find('.cart__total-value').attr('value');

//         $('.cart__total-value').attr('cart-total-pice', newTotalAttr || '0');
//         $('.cart__total-value').attr('value', newTotalValue || '0');

//         const totalCart =
//           parseFloat((newTotalAttr || newTotalValue || '0').replace(/,/g, '')) ||
//           0;

//         const currentCard = $(
//           `article.cart-item-card[data-key="${itemKey}"]`
//         );

//         currentCard.remove();

//         if (rushItemKey) {
//           $(`article.cart-item-card[data-key="${rushItemKey}"]`).remove();
//         }

//         if ($('#use-credits-toggle').is(':checked')) {
//           recalculateCreditTotals(totalCart);
//         }

//       },

//       error: function (xhr, status, error) {
//         console.log('Cart refresh error:', error);
//       },
//     });
//   } catch (error) {
//     console.error('Remove failed:', error);
//   } finally {
//     setTimeout(() => {
//       $cartInner.css({
//         opacity: '1',
//         pointerEvents: '',
//       });

//       $('cart-items-component .cart__total-container').removeClass('active');
//     }, 400);
//   }
// });


// $(document)
//   .off('click.cartRemove', '.cart-item-card__remove')
//   .on('click.cartRemove', '.cart-item-card__remove', async function (e) {
//     e.preventDefault();
//     e.stopPropagation();

//     const $currentItem = $(this).closest('article.cart-item-card');
//     const itemKey = $currentItem.attr('data-key');

//     if (!itemKey) {
//       console.log('Cart item key missing');
//       return;
//     }

//     const itemText = $currentItem.text();
//     const isCustomVocalOrder = itemText.includes('Custom Vocal Order');
//     const isRushCharge = itemText.includes('Rush Charges');

//     const $cartInner = $('.cart-drawer__inner');

//     $cartInner.css({
//       opacity: '0.5',
//       pointerEvents: 'none',
//       transition: '0.2s ease',
//     });

//     $('cart-items-component .cart__total-container').addClass('active');

//     try {
//       const cartBeforeRemove = await fetch('/cart.js', {
//         cache: 'no-store',
//       }).then((r) => r.json());

//       let linkedItemKey = null;

//       if (isCustomVocalOrder) {
//         const rushItem = cartBeforeRemove.items.find((item) =>
//           item.product_title === 'Rush Charges' ||
//           item.title.includes('Rush Charges') ||
//           item.properties?._rush_charge === 'true'
//         );

//         linkedItemKey = rushItem?.key || null;
//       }

//       if (isRushCharge) {
//         const customItem = cartBeforeRemove.items.find((item) =>
//           item.product_title === 'Custom Vocal Order' &&
//           item.properties &&
//           Object.keys(item.properties).some((key) =>
//             key.includes('Your Name')
//           )
//         );

//         linkedItemKey = customItem?.key || null;
//       }

//       const updates = {
//         [itemKey]: 0,
//       };

//       if (linkedItemKey) {
//         updates[linkedItemKey] = 0;
//       }

//       const changeResponse = await fetch('/cart/update.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           Accept: 'application/json',
//         },
//         body: JSON.stringify({ updates }),
//       });

//       if (!changeResponse.ok) {
//         throw new Error('Cart item remove failed');
//       }

//       const finalCartData = await changeResponse.json();

//       let displayCount = 0;

//       finalCartData.items.forEach((item) => {
//         const hasCustomProperty =
//           item.properties &&
//           Object.keys(item.properties).some((key) =>
//             key.includes('Your Name')
//           );

//         if (hasCustomProperty) {
//           displayCount += 1;
//         } else {
//           displayCount += item.quantity;
//         }
//       });

//       const cartHeading = document.querySelector('#cart-drawer-heading');

//       if (cartHeading) {
//         cartHeading.textContent = `Cart (${displayCount})`;
//       }

//       const bubble = document.querySelector('.cart-bubble__text-count');

//       if (bubble) {
//         bubble.textContent = displayCount;
//         bubble.setAttribute('data-unique-count', displayCount);
//       }

//       document
//         .querySelectorAll(
//           '[data-cart-count], .cart-count-bubble span, .header__cart-count, .cart-count'
//         )
//         .forEach((el) => {
//           el.textContent = displayCount;
//         });

//       document.dispatchEvent(
//         new CustomEvent('cart:updated', {
//           bubbles: true,
//           detail: {
//             cart: finalCartData,
//           },
//         })
//       );

//       $.ajax({
//         url: window.location.href,
//         type: 'GET',
//         cache: false,

//         success: function (response) {
//           const $response = $(response);

//           const newTotal = $response.find('[data-cart-subtotal]').text();
//           $('[data-cart-subtotal]').text(newTotal);

//           const newTotalAttr = $response
//             .find('.cart__total-value')
//             .attr('cart-total-pice');

//           const newTotalValue = $response
//             .find('.cart__total-value')
//             .attr('value');

//           $('.cart__total-value').attr('cart-total-pice', newTotalAttr || '0');
//           $('.cart__total-value').attr('value', newTotalValue || '0');

//           const totalCart =
//             parseFloat((newTotalAttr || newTotalValue || '0').replace(/,/g, '')) ||
//             0;

//           $(`article.cart-item-card[data-key="${itemKey}"]`).remove();

//           if (linkedItemKey) {
//             $(`article.cart-item-card[data-key="${linkedItemKey}"]`).remove();
//           }

//           if ($('#use-credits-toggle').is(':checked')) {
//             recalculateCreditTotals(totalCart);
//           }
//         },

//         error: function (xhr, status, error) {
//           console.log('Cart refresh error:', error);
//         },
//       });
//     } catch (error) {
//       console.error('Remove failed:', error);
//     } finally {
//       setTimeout(() => {
//         $cartInner.css({
//           opacity: '1',
//           pointerEvents: '',
//         });

//         $('cart-items-component .cart__total-container').removeClass('active');
//       }, 400);
//     }
//   });



$(document)
  .off('click.cartRemove', '.cart-item-card__remove')
  .on('click.cartRemove', '.cart-item-card__remove', async function (e) {
    e.preventDefault();
    e.stopPropagation();

    const $currentItem = $(this).closest('article.cart-item-card');
    const itemKey = $currentItem.attr('data-key');

    if (!itemKey) {
      console.log('Cart item key missing');
      return;
    }

    const itemText = $currentItem.text();

    const isCustomVocalOrder =
      itemText.includes('Custom Vocal Order');

    const isRushCharge =
      itemText.includes('Rush Charges');

    const $cartInner = $('.cart-drawer__inner');

    $cartInner.css({
      opacity: '0.5',
      pointerEvents: 'none',
      transition: '0.2s ease',
    });

    $('cart-items-component .cart__total-container')
      .addClass('active');

    try {
      const cartBeforeRemove = await fetch('/cart.js', {
        cache: 'no-store',
      }).then((r) => r.json());

      const linkedItemKeys = [];

      /*
       * If user removes Rap or Song Custom Vocal Order:
       * remove ALL Custom Vocal Order variants
       * + Rush Charges
       */
      if (isCustomVocalOrder) {
        cartBeforeRemove.items.forEach((item) => {
          const isCustomOrder =
            item.product_title === 'Custom Vocal Order' ||
            item.title?.includes('Custom Vocal Order');

          const isRush =
            item.product_title === 'Rush Charges' ||
            item.title?.includes('Rush Charges') ||
            item.properties?._rush_charge === 'true';

          if (isCustomOrder || isRush) {
            linkedItemKeys.push(item.key);
          }
        });
      }

      /*
       * If user removes Rush Charges:
       * remove ALL Custom Vocal Order variants
       * + Rush Charges itself
       */
      if (isRushCharge) {
        cartBeforeRemove.items.forEach((item) => {
          const isCustomOrder =
            item.product_title === 'Custom Vocal Order' ||
            item.title?.includes('Custom Vocal Order');

          const isRush =
            item.product_title === 'Rush Charges' ||
            item.title?.includes('Rush Charges') ||
            item.properties?._rush_charge === 'true';

          if (isCustomOrder || isRush) {
            linkedItemKeys.push(item.key);
          }
        });
      }

      const updates = {};

      // Always remove clicked item
      updates[itemKey] = 0;

      // Remove all linked Custom Vocal / Rush items
      linkedItemKeys.forEach((key) => {
        updates[key] = 0;
      });

      console.log('Removing cart items:', updates);

      const changeResponse = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          updates,
        }),
      });

      if (!changeResponse.ok) {
        throw new Error('Cart item remove failed');
      }

      const finalCartData =
        await changeResponse.json();

      let displayCount = 0;

      finalCartData.items.forEach((item) => {
        const hasCustomProperty =
          item.properties &&
          Object.keys(item.properties).some((key) =>
            key.includes('Your Name')
          );

        if (hasCustomProperty) {
          displayCount += 1;
        } else {
          displayCount += item.quantity;
        }
      });

      const cartHeading =
        document.querySelector('#cart-drawer-heading');

      if (cartHeading) {
        cartHeading.textContent =
          `Cart (${displayCount})`;
      }

      const bubble =
        document.querySelector('.cart-bubble__text-count');

      if (bubble) {
        bubble.textContent = displayCount;
        bubble.setAttribute(
          'data-unique-count',
          displayCount
        );
      }

      document
        .querySelectorAll(
          '[data-cart-count], .cart-count-bubble span, .header__cart-count, .cart-count'
        )
        .forEach((el) => {
          el.textContent = displayCount;
        });

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: {
            cart: finalCartData,
          },
        })
      );

      $.ajax({
        url: window.location.href,
        type: 'GET',
        cache: false,

        success: function (response) {
          const $response = $(response);

          const newTotal =
            $response
              .find('[data-cart-subtotal]')
              .text();

          $('[data-cart-subtotal]')
            .text(newTotal);

          const newTotalAttr =
            $response
              .find('.cart__total-value')
              .attr('cart-total-pice');

          const newTotalValue =
            $response
              .find('.cart__total-value')
              .attr('value');

          $('.cart__total-value')
            .attr(
              'cart-total-pice',
              newTotalAttr || '0'
            );

          $('.cart__total-value')
            .attr(
              'value',
              newTotalValue || '0'
            );

          const totalCart =
            parseFloat(
              (
                newTotalAttr ||
                newTotalValue ||
                '0'
              ).replace(/,/g, '')
            ) || 0;

          /*
           * Remove every item from DOM
           * that was included in updates
           */
          Object.keys(updates).forEach((key) => {
            $(
              `article.cart-item-card[data-key="${key}"]`
            ).remove();
          });

          if (
            $('#use-credits-toggle')
              .is(':checked')
          ) {
            recalculateCreditTotals(
              totalCart
            );
          }
        },

        error: function (
          xhr,
          status,
          error
        ) {
          console.log(
            'Cart refresh error:',
            error
          );
        },
      });
    } catch (error) {
      console.error(
        'Remove failed:',
        error
      );
    } finally {
      setTimeout(() => {
        $cartInner.css({
          opacity: '1',
          pointerEvents: '',
        });

        $(
          'cart-items-component .cart__total-container'
        ).removeClass('active');
      }, 400);
    }
  });
